module.exports = __webpack_public_path__ + "static/img/2.d8cac9b8.jpg";